var l = Object.defineProperty;
var c = (n, e, t) => e in n ? l(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var i = (n, e, t) => c(n, typeof e != "symbol" ? e + "" : e, t);
import { jwtDecode as u } from "jwt-decode";
import p from "./api.mjs";
import k from "./clients/feed/index.mjs";
import m from "./clients/messages/index.mjs";
import f from "./clients/ms-teams/index.mjs";
import d from "./clients/objects/index.mjs";
import T from "./clients/preferences/index.mjs";
import C from "./clients/slack/index.mjs";
import g from "./clients/users/index.mjs";
const w = "https://api.knock.app";
class v {
  constructor(e, t = {}) {
    i(this, "host");
    i(this, "apiClient", null);
    i(this, "userId");
    i(this, "userToken");
    i(this, "logLevel");
    i(this, "tokenExpirationTimer", null);
    i(this, "feeds", new k(this));
    i(this, "objects", new d(this));
    i(this, "preferences", new T(this));
    i(this, "slack", new C(this));
    i(this, "msTeams", new f(this));
    i(this, "user", new g(this));
    i(this, "messages", new m(this));
    if (this.apiKey = e, this.host = t.host || w, this.logLevel = t.logLevel, this.log("Initialized Knock instance"), this.apiKey && this.apiKey.startsWith("sk_"))
      throw new Error(
        "[Knock] You are using your secret API key on the client. Please use the public key."
      );
  }
  client() {
    return this.apiClient || (this.apiClient = this.createApiClient()), this.apiClient;
  }
  /*
    Authenticates the current user. In non-sandbox environments
    the userToken must be specified.
  */
  authenticate(e, t, s) {
    let r = !1;
    this.apiClient && (this.userId !== e || this.userToken !== t) && (this.log("userId or userToken changed; reinitializing connections"), this.feeds.teardownInstances(), this.teardown(), r = !0), this.userId = e, this.userToken = t, this.log(`Authenticated with userId ${e}`), this.userToken && (s == null ? void 0 : s.onUserTokenExpiring) instanceof Function && this.maybeScheduleUserTokenExpiration(
      s.onUserTokenExpiring,
      s.timeBeforeExpirationInMs
    ), r && (this.apiClient = this.createApiClient(), this.feeds.reinitializeInstances(), this.log("Reinitialized real-time connections"));
  }
  /*
    Returns whether or this Knock instance is authenticated. Passing `true` will check the presence
    of the userToken as well.
  */
  isAuthenticated(e = !1) {
    return e ? !!(this.userId && this.userToken) : !!this.userId;
  }
  // Used to teardown any connected instances
  teardown() {
    var e;
    this.tokenExpirationTimer && clearTimeout(this.tokenExpirationTimer), (e = this.apiClient) != null && e.socket && this.apiClient.socket.isConnected() && this.apiClient.socket.disconnect();
  }
  log(e) {
    this.logLevel === "debug" && console.log(`[Knock] ${e}`);
  }
  /**
   * Initiates an API client
   */
  createApiClient() {
    return new p({
      apiKey: this.apiKey,
      host: this.host,
      userToken: this.userToken
    });
  }
  async maybeScheduleUserTokenExpiration(e, t = 3e4) {
    if (!this.userToken) return;
    const s = u(this.userToken), r = (s.exp ?? 0) * 1e3, o = Date.now();
    if (r && r > o) {
      const a = r - t - o;
      this.tokenExpirationTimer = setTimeout(async () => {
        const h = await e(this.userToken, s);
        typeof h == "string" && this.authenticate(this.userId, h, {
          onUserTokenExpiring: e,
          timeBeforeExpirationInMs: t
        });
      }, a);
    }
  }
}
export {
  v as default
};
//# sourceMappingURL=knock.mjs.map
